<div id="lista" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div 
            class="header accent"
            fxLayout="column" 
            fxLayoutAlign="center center"
            fxLayout.gt-sm="row" 
            fxLayoutAlign.gt-sm="space-between center"
        >
            <!-- APP TITLE -->
            <div fxLayout="column" fxLayoutAlign="center start">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="secondary-text s-18">home</mat-icon>
                    <mat-icon class="secondary-text s-16">chevron_right</mat-icon>
                    <span class="secondary-text pointer" style="cursor: pointer;" (click)="back()">Lista de Trades</span>
                </div>
                <div class="h1 mt-16"> {{titulo}} </div>
            </div>
            <!-- / APP TITLE -->   

            <div 
                class="add-product-button mb-24 mb-md-0" 
                fxLayout="row" 
                fxLayoutAlign="start center">
                
                    <!-- ADD BUTTON -->
                <button mat-raised-button mat-icon-button [matMenuTriggerFor]="animals">
                    <mat-icon>settings_applications</mat-icon>
                </button>
                <!-- / ADD BUTTON -->
                <mat-menu #animals="matMenu">
                    <button mat-menu-item (click)="openFiltro()">
                        <mat-icon>search</mat-icon>
                        CONSULTAR
                    </button>
                </mat-menu>
            </div>
        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card"> 
            <ngx-datatable 
                #table 
                class='material striped' 
                [loadingIndicator]="loadingIndicator"
                [columns]="columns"
                [columnMode]="'force'" 
                [headerHeight]="50"
                [footerHeight]="50" 
                [rowHeight]="'auto'"                
                (sort)="onSort($event)"
                [rows]='rows'
                [rowClass]="getRowClass"
            >

                <ngx-datatable-column name="Cliente" prop="cliente" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-cliente="value" ngx-datatable-cell-template>
                        {{cliente.numero_xp}} - {{cliente.nome}}
                    </ng-template>
                </ngx-datatable-column> 
                

                <ngx-datatable-column name="Qtd." prop="compra_qtd_executada" [sortable]="false" [width]="80">
                    <ng-template let-rowIndex="rowIndex" let-compra_qtd_executada="value" ngx-datatable-cell-template>
                        {{ compra_qtd_executada | number : '1.0-0' }}
                    </ng-template>
                </ngx-datatable-column>                

                <ngx-datatable-column name="Compra" prop="compra_preco_executado" [sortable]="false" [width]="80">
                    <ng-template let-rowIndex="rowIndex" let-compra_preco_executado="value" ngx-datatable-cell-template>
                        R$ {{ compra_preco_executado | number : '1.2-2' }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Venda" prop="venda_preco_executado" [sortable]="false" [width]="80">
                    <ng-template let-rowIndex="rowIndex" let-venda_preco_executado="value" ngx-datatable-cell-template>
                        {{ (venda_preco_executado == null ? 0 : venda_preco_executado) | number : '1.2-2' }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="%" prop="percentual" [sortable]="false" [width]="80">
                    <ng-template let-rowIndex="rowIndex" let-percentual="value" ngx-datatable-cell-template>
                        {{ percentual | number : '1.2-2' }} %
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Vol. Financeiro Compra" prop="volume_financeiro_inicial" [sortable]="false" [width]="150">
                    <ng-template let-rowIndex="rowIndex" let-volume_financeiro_inicial="value" ngx-datatable-cell-template>
                        R$ {{ volume_financeiro_inicial | number : '1.2-2' }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Vol. Financeiro Venda" prop="volume_financeiro_final" [sortable]="false" [width]="150">
                    <ng-template let-rowIndex="rowIndex" let-volume_financeiro_final="value" ngx-datatable-cell-template>
                        R$ {{ volume_financeiro_final | number : '1.2-2' }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Vol. Financeiro Trade" prop="volume_financeiro_total" [sortable]="false" [width]="150">
                    <ng-template let-rowIndex="rowIndex" let-volume_financeiro_total="value" ngx-datatable-cell-template>
                        R$ {{ volume_financeiro_total | number : '1.2-2' }}
                    </ng-template>
                </ngx-datatable-column>
                

            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator 
                    #paginator 
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>